function initializePageScroll() {
  const scrollTarget = document.querySelector('body')
  const scrollDistance = 100
  const scrollClass = 'page-scroll'
  const initialClass = 'page-initial'

  document.addEventListener('scroll', (event) => {
    updatePageScroll()
  })
  scrollTarget.classList.remove(initialClass)
  updatePageScroll()

  function updatePageScroll() {
    if (window.scrollY >= scrollDistance) {
      scrollTarget.classList.add(scrollClass)
    } else {
      scrollTarget.classList.remove(scrollClass)
    }
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  initializePageScroll()
})